import { ApiError, fetchWithAuth } from "@entities/user-tokens";

/**
 * スライドフォーマットの実体（PPTX）をダウンロードする（プレビュー/DL 用）。
 *
 * ①認証付きで `{ url, fileName }`（presigned GET）を取得 → ②その URL から実体を取得。
 * ルートは Web と同じ `/slide-formats/:id`（アドイン CloudFront が業務 API へ振り分け済み）。
 */
export async function downloadSlideFormat(
    formatId: string
): Promise<{ blob: Blob; fileName: string | null }> {
    const res = await fetchWithAuth(`/slide-formats/${formatId}`, {
        headers: { Accept: "application/octet-stream" },
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "フォーマットの取得に失敗しました");
    const { url, fileName } = (await res.json()) as { url: string; fileName: string | null };

    const fileRes = await fetch(url);
    if (!fileRes.ok) throw new Error(`ファイル本体の取得に失敗しました (status ${fileRes.status})`);
    // Content-Disposition: attachment 付きの大きなクロスオリジン S3 応答では Chrome の
    // `res.blob()` が body 読み取り中に net::ERR_FAILED("Failed to fetch")になる既知事象があるため、
    // arrayBuffer 経由で Blob を構築して回避する（Web の fetchFileBlob と同じ回避策）。
    const buffer = await fileRes.arrayBuffer();
    const type = fileRes.headers.get("content-type") ?? "application/octet-stream";
    return { blob: new Blob([buffer], { type }), fileName };
}
